/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Skeleton } from "primereact/skeleton";
import { accessAPI, Boton, Titulo } from "../../shared";

const sinResultados = { color: "var(--rojo)", margin: 0 };

/**
 * Evaluación de la solicitud: por cada norma y esquema de sus procesos, los
 * colaboradores con la formación requerida para cada tipo de colaborador y los
 * laboratorios aceptados para la norma.
 *
 * @param {number} recarga cambia cada vez que se crea un proceso, para volver a
 *        evaluar
 */
export default function TarjetaEvaluacionSolicitud({ solicitud, recarga, toast }) {
  const [evaluaciones, setEvaluaciones] = useState(null);

  useEffect(() => {
    accessAPI(
      "GET",
      `admin/proceso/solicitud/${solicitud.id}/evaluacion`,
      null,
      (respuesta) => setEvaluaciones(respuesta),
      (respuesta) => {
        setEvaluaciones([]);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al evaluar la solicitud",
          sticky: true
        });
      }
    );
  }, [solicitud.id, recarga, toast]);

  return (
    <Card>
      <Titulo>Revisión de solicitud</Titulo>

      {!evaluaciones && (
        <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} width="100%" height="2.5rem" />
          ))}
        </div>
      )}

      {evaluaciones && evaluaciones.length === 0 && (
        <p css={{ color: "var(--grisTextos)" }}>
          Todavía no hay procesos para evaluar.
        </p>
      )}

      {evaluaciones?.map((evaluacion, indice) => (
        <div key={`${evaluacion.norma?.id || "sin"}-${evaluacion.esquema.id}`}>
          {indice > 0 && <Divider />}

          {/* Para qué norma y esquema se hizo la evaluación */}
          <div css={{ fontWeight: 600 }}>
            {evaluacion.norma
              ? `${evaluacion.norma.numero} - ${evaluacion.norma.nombre}`
              : "Sin norma"}
          </div>
          <div css={{ color: "var(--grisTextos)", fontSize: "0.85em" }}>
            {evaluacion.esquema.etiqueta} ·{" "}
            {evaluacion.procesos.map((p) => p.nombre).join(", ")}
          </div>

          <div
            css={{
              display: "flex",
              flexDirection: "column",
              gap: "1em",
              marginTop: "1em"
            }}
          >
            {evaluacion.tiposColaborador.map((tipo) => (
              <div key={tipo.id}>
                <div css={{ fontWeight: 500 }}>{tipo.nombre}</div>
                {tipo.colaboradores.length === 0 ? (
                  <p css={sinResultados}>
                    No hay colaboradores con la formación requerida.
                  </p>
                ) : (
                  <div css={{ display: "flex", flexDirection: "column" }}>
                    {tipo.colaboradores.map((colaborador) => (
                      <div key={colaborador.id}>
                        <Boton
                          texto
                          chico
                          uri={`/proveedores/auditores/${colaborador.id}?volver=/procesos/solicitudes/${solicitud.id}`}
                        >
                          {`${colaborador.nombre} ${colaborador.apellido}`}
                        </Boton>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}

            <div>
              <div css={{ fontWeight: 500 }}>Laboratorios</div>
              {evaluacion.laboratorios.length === 0 ? (
                <p css={sinResultados}>
                  {evaluacion.norma
                    ? "No hay laboratorios aceptados para la norma."
                    : "Los procesos no tienen norma."}
                </p>
              ) : (
                <div css={{ display: "flex", flexDirection: "column" }}>
                  {evaluacion.laboratorios.map((laboratorio) => (
                    <div key={laboratorio.id}>
                      <Boton
                        texto
                        chico
                        uri={`/proveedores/laboratorios/${laboratorio.id}?volver=/procesos/solicitudes/${solicitud.id}`}
                      >
                        {laboratorio.nombre}
                      </Boton>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </Card>
  );
}
